import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Calendar, MapPin } from "lucide-react";

const formatLong = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" }); } catch { return iso; }
};

export default function AnnouncementsSection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section
      data-testid="announcements-section"
      className="bg-white rounded-2xl border-2 border-[#D1C9C1] shadow-sm overflow-hidden"
    >
      <div className="bg-[#D97706] text-white px-5 py-3 flex items-center gap-2">
        <span className="text-xl">📣</span>
        <h2 className="font-serif text-lg sm:text-xl font-bold">Anuncios</h2>
      </div>
      <div className="divide-y divide-[#D1C9C1]">
        {items.map((a) => (
          <article key={a.id} className="p-5 sm:p-6" data-testid={`announcement-${a.id}`}>
            <h3 className="font-serif text-xl font-bold text-[#1A1818] mb-1">{a.title}</h3>
            <p className="text-base text-[#4A4646] leading-relaxed whitespace-pre-wrap mb-3">{a.description}</p>
            <div className="flex flex-wrap gap-4 text-sm text-[#4A4646]">
              {a.event_date && (
                <div className="flex items-center gap-1.5">
                  <Calendar className="w-4 h-4 text-[#D97706]" />
                  <span>{formatLong(a.event_date)}</span>
                </div>
              )}
              {a.location && (
                <div className="flex items-center gap-1.5">
                  <MapPin className="w-4 h-4 text-[#D97706]" />
                  <span>{a.location}</span>
                </div>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
